import type { ClaimEvidenceMap, GroundedAnswer } from "@gencow/core";
import { dedupeCitations } from "./server-grounding-common.js";

export function finalizeGroundedAnswer(claims: ClaimEvidenceMap[]): GroundedAnswer {
  const citations = dedupeCitations(claims.flatMap((claim) => claim.citations));
  const insufficient = claims.filter((claim) => claim.status === "insufficient_evidence");
  const partial = claims.filter((claim) => claim.status === "partially_supported");
  const warnings = [
    ...(insufficient.length > 0 ? [`${insufficient.length} claim(s) have insufficient evidence`] : []),
    ...(partial.length > 0 ? [`${partial.length} claim(s) are partially supported`] : []),
  ];

  return {
    answer: buildAnswerText(claims),
    claims,
    citations,
    warnings,
    grounded: insufficient.length === 0,
  };
}

function buildAnswerText(claims: ClaimEvidenceMap[]): string {
  const visibleClaims = claims.filter((claim) => claim.status !== "insufficient_evidence");
  if (visibleClaims.length === 0) {
    return "I could not find enough evidence to answer confidently.";
  }

  return visibleClaims
    .map((claim) =>
      claim.status === "partially_supported" ? `${claim.claimText} (partially supported)` : claim.claimText,
    )
    .join("\n");
}
